import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "trezo-card bg-white dark:bg-[#0c1427] mb-[25px] p-[20px] md:p-[25px] rounded-md" }
const _hoisted_2 = { class: "trezo-card-content relative" }
const _hoisted_3 = { class: "block" }
const _hoisted_4 = {
  key: 0,
  class: "mb-0 mt-[3px] text-[20px]"
}
const _hoisted_5 = {
  key: 1,
  class: "mb-0 mt-[3px] text-[20px]"
}
const _hoisted_6 = { class: "text-base" }
const _hoisted_7 = { class: "absolute -top-[28px] ltr:-right-[9px] rtl:-left-[9px] max-w-[120px]" }
const _hoisted_8 = { class: "mt-[25px] md:mt-[34px] flex items-center justify-between" }
const _hoisted_9 = {
  key: 0,
  class: "inline-block text-sm text-gray-500 py-[1px] px-[8.3px] rounded-xl"
}
const _hoisted_10 = { class: "block text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_apexchart = _resolveComponent("apexchart")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.directT('dashboard.crm.leadConversion')), 1),
      (_ctx.loading)
        ? (_openBlock(), _createElementBlock("h5", _hoisted_4, _toDisplayString(_ctx.directT('dashboard.crm.loading')), 1))
        : (!_ctx.hasPreviousPeriodData)
          ? (_openBlock(), _createElementBlock("h5", _hoisted_5, _toDisplayString(_ctx.conversionRate) + "% ", 1))
          : (_openBlock(), _createElementBlock("h5", {
              key: 2,
              class: _normalizeClass(["mb-0 mt-[3px] text-[20px]", {
        'text-success-600': _ctx.percentageDifference > 0,
        'text-danger-600': _ctx.percentageDifference < 0,
        'text-gray-600': _ctx.percentageDifference === 0
      }])
            }, [
              _createTextVNode(_toDisplayString(_ctx.conversionRate) + "% ", 1),
              _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.percentageDifference > 0 ? '+' : '') + _toDisplayString(_ctx.percentageDifference) + "%", 1)
            ], 2)),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.isClient)
          ? (_openBlock(), _createBlock(_component_apexchart, {
              key: 0,
              type: "area",
              height: "95",
              options: _ctx.barOptions,
              series: _ctx.series
            }, null, 8, ["options", "series"]))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_8, [
        (!_ctx.hasPreviousPeriodData)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_ctx.directT('dashboard.noPreviousData')), 1))
          : (_openBlock(), _createElementBlock("span", {
              key: 1,
              class: _normalizeClass(["inline-block text-sm py-[1px] px-[8.3px] border rounded-xl", {
            'text-success-700 border-success-300 bg-success-100': _ctx.percentageDifference > 0,
            'text-danger-700 border-danger-300 bg-danger-100': _ctx.percentageDifference < 0,
            'text-gray-700 border-gray-300 bg-gray-100': _ctx.percentageDifference === 0
          }])
            }, _toDisplayString(_ctx.percentageDifference > 0 ? '+' : '') + _toDisplayString(_ctx.percentageDifference) + "% ", 3)),
        _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.directT('dashboard.last30Days')), 1)
      ])
    ])
  ]))
}